<template>
    <!-- Center The Modal -->
    <div class="">
        <notification-modal     :give-option="true"
                                :show-icon="false"
                                :z-index="'z-0'"
                                max-width="sm:max-w-lg"
                                @primary-action="$emit('primary')"
                                @secondary-action="$emit('secondary')"
        >
            <template   #button-primary-content>
                On-Demand Report
            </template>

            <template   #button-secondary-content>
                Group Reporting Template
            </template>

            <template   #title-content>
                {{ reportName }}
            </template>

            SoniCloud's reporting has two different methods for generating reports:<br/><br/>
            <ul class="list-disc list-inside text-justify mx-4">
                <li class="mb-2">
                  <b class="text-blue-600">On-Demand Report</b>: Create an on-demand report by customizing all options
                  for this report. You'll receive the email in your inbox and your colleagues won't be able to see
                  the results in SoniCloud.
                </li>
                <li>
                  <b class="text-blue-600">Group Reporting Templates</b>: Leverage your SoniCloud groups to schedule
                  multiple reports for your groups, or run one of these scheduled reports right now!
                </li>
            </ul>
        </notification-modal>
    </div>
</template>

<script>
import axios from "axios"
import {companyMixin} from '@/mixins/companyMixin'
import {permissionMixin} from '@/mixins/permissionMixin'
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import NotificationModal from "../elements/NotificationModal";

export default {
    name: "ReportHomeModal",
    mixins: [companyMixin, permissionMixin, iconNamesMixin],
    components: {NotificationModal},
    emits: ['primary', 'secondary',],
    props: {
        // The route that will be gone to when the
        reportRoute: {
            type: String,
        },
        reportName: {
            type: String,
            default: 'Report'
        },
    },
    data() {
        return {}
    },
    created() {

    },
    mounted() {

    },
    methods: {},
    computed: {},
    watch: {},
}
</script>

<style scoped>

</style>